export const isValidDate = (date: any): date is Date => {
  if (date.getMonth && date.getMonth() >= 0 && !Number.isNaN(date.getMonth())) {
    return true
  }

  return false
}
